var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "app-main-content" }, [
    _c(
      "div",
      { staticClass: "tabs-container" },
      [
        _c(
          "el-tabs",
          {
            staticStyle: { width: "100%" },
            attrs: { type: "card" },
            on: { "tab-click": _vm.handleTabClick },
            model: {
              value: _vm.activeTabName,
              callback: function($$v) {
                _vm.activeTabName = $$v
              },
              expression: "activeTabName"
            }
          },
          [
            _c(
              "el-tab-pane",
              {
                attrs: {
                  label: _vm.$t("CargoMsg.Cargo_VehicleRequestForm"),
                  name: "useCarApplicationFormTab"
                }
              },
              [
                _c("use-car-application-form-tab", {
                  ref: "useCarApplicationFormTab",
                  attrs: {
                    lob: _vm.lob,
                    source: _vm.SystemConstants.LOAD_POOL_SOURCE_HOME_PAGE.code
                  }
                })
              ],
              1
            ),
            _c(
              "el-tab-pane",
              {
                attrs: {
                  label: _vm.$t("CargoMsg.Cargo_VehicleOrder"),
                  name: "carFormTab"
                }
              },
              [
                _c("car-form-tab", {
                  ref: "carFormTab",
                  attrs: { lob: _vm.lob }
                })
              ],
              1
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }